import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import chooseZodiac from "@/views/chooseZodiac/chooseZodiac.vue"; // import horoscopeDetails from "@/views/horoscopeDetails/horoscopeDetails.vue";
// import confirmPhoto from "@/views/confirmPhoto/confirmPhoto.vue";
// import ageingPhoto from "@/views/ageingPhoto/ageingPhoto.vue";
// import setting from "@/views/setting/setting.vue";

import beautyContest from "@/views/beautyContest/beautyContest.vue"; // import beautyContestResult from "@/views/beautyContestResult/beautyContestResult.vue";

import beautyContestScaning from "@/views/beautyContestScaning/beautyContestScaning.vue";
import personalFutrue from "@/views/personalFutrue/personalFutrue.vue"; // import personalFutrueResult from "@/views/personalFutrue/personalFutrueResult.vue";

import ethnicityScanner from "@/views/ethnicityScanner/ethnicityScanner.vue";
import vipcenter from "@/views/vipcenter/vipcenter.vue";
import vipPage from "@/views/vipPage/vipPage.vue";
import vipPlanC from "@/views/vipPlanC/vipPlanC.vue";
import vipPlanF from "@/views/vipPlanF/vipPlanF.vue";
import vipPlanFnew from "@/views/vipPlanF/vipPlanFnew.vue";
import futureBaby from "@/views/futureBaby/futureBaby.vue"; // import futureBabyResult from "@/views/futureBaby/futureBabyResult.vue";

import futureBabyInput from "@/views/futureBaby/futureBabyInput.vue";
import composeProcess from "@/views/futureBaby/composeProcess.vue";
import cameraGuide from "@/views/cameraGuide/cameraGuide.vue";
import confirmPhoto from "@/views/confirmPhoto/confirmPhoto.vue";
import vipFullToast from "@/views/vipFullToast/vipFullToast.vue"; //异步的路由:

var setting = function setting() {
  return import("@/views/setting/setting.vue");
}; // const confirmPhoto = () => import("@/views/confirmPhoto/confirmPhoto.vue");


var horoscopeDetails = function horoscopeDetails() {
  return import("@/views/horoscopeDetails/horoscopeDetails.vue");
};

var horoscopePage = function horoscopePage() {
  return import("@/views/horoscopePage/horoscopePage.vue");
};

var futureBabyResult = function futureBabyResult() {
  return import("@/views/futureBaby/futureBabyResult.vue");
};

var beautyContestResult = function beautyContestResult() {
  return import("@/views/beautyContestResult/beautyContestResult.vue");
};

var zodiacMatch = function zodiacMatch() {
  return import("@/views/zodiacMatch/zodiacMatch.vue");
};

var zodiacMatchResult = function zodiacMatchResult() {
  return import("@/views/zodiacMatch/zodiacMatchResult.vue");
};

var loveCompatibility = function loveCompatibility() {
  return import("@/views/loveCompatibility/loveCompatibility.vue");
};

var loveCompatibilityResult = function loveCompatibilityResult() {
  return import("@/views/loveCompatibility/loveCompatibilityResult.vue");
};

var palmistryResult = function palmistryResult() {
  return import("@/views/palmistry/palmistryResult.vue");
};

var genderSwitch = function genderSwitch() {
  return import("@/views/genderSwitch/genderSwitch.vue");
};

var loveConsultant = function loveConsultant() {
  return import("@/views/loveConsultant/loveConsultant.vue");
};

var wealthForecast = function wealthForecast() {
  return import("@/views/wealthForecast/wealthForecast.vue");
};

var ageingPhoto = function ageingPhoto() {
  return import("@/views/ageingPhoto/ageingPhoto.vue");
};

var palmPrintReading = function palmPrintReading() {
  return import("@/views/palmPrintReading/palmPrintReading.vue");
};

var palmPrintQuestion = function palmPrintQuestion() {
  return import("@/views/palmPrintReading/palmPrintQuestion.vue");
};

var palmPrintResult = function palmPrintResult() {
  return import("@/views/palmPrintReading/palmPrintResult.vue");
};

var faceReading = function faceReading() {
  return import("@/views/faceReading/faceReading.vue");
};

var faceReadingTypes = function faceReadingTypes() {
  return import("@/views/faceReading/faceReadingTypes.vue");
};

var faceReadingQuestion = function faceReadingQuestion() {
  return import("@/views/faceReading/faceReadingQuestion.vue");
};

var faceReadingResult = function faceReadingResult() {
  return import("@/views/faceReading/faceReadingResult.vue");
};

var test = function test() {
  return import("@/views/test/test.vue");
};

var chooseCelebrate = function chooseCelebrate() {
  return import("@/views/chooseCelebrate/chooseCelebrate.vue");
};

var chooseAnotherPhoto = function chooseAnotherPhoto() {
  return import("@/views/chooseCelebrate/chooseAnotherPhoto.vue");
};

var getCelebrites = function getCelebrites() {
  return import("@/views/getCelebrites/getCelebrites.vue");
};

var articalResult = function articalResult() {
  return import("@/views/readResult/articalResult.vue");
};

var galleryResult = function galleryResult() {
  return import("@/views/readResult/galleryResult.vue");
};

var ReadListPage = function ReadListPage() {
  return import("@/views/readResult/readListPage.vue");
};

var GetNewCelebrites = function GetNewCelebrites() {
  return import("@/views/getNewCelebrites/getNewCelebrites.vue");
};

Vue.use(Router);
var staticRouters = [{
  path: "/",
  redirect: "/home"
}, {
  path: "/home",
  name: "home",
  component: Home
}, {
  path: "/chooseZodiac",
  name: "chooseZodiac",
  component: chooseZodiac
}, {
  path: "/cameraGuide",
  name: "cameraGuide",
  component: cameraGuide
}, {
  path: "/horoscopeDetails",
  name: "horoscopeDetails",
  component: horoscopeDetails
}, {
  path: "/test",
  name: "test",
  component: test
}, {
  path: "/confirmPhoto",
  name: "confirmPhoto",
  component: confirmPhoto
}, {
  path: "/ageingPhoto",
  name: "ageingPhoto",
  component: ageingPhoto
}, {
  path: "/vipFullToast",
  name: "vipFullToast",
  component: vipFullToast
}, {
  path: "/genderSwitch",
  name: "genderSwitch",
  component: genderSwitch
}, {
  path: "/setting",
  name: "setting",
  component: setting
}, {
  path: "/beautyContest",
  name: "beautyContest",
  component: beautyContest
}, {
  path: "/futureBaby",
  name: "futureBaby",
  component: futureBaby
}, {
  path: "/futureBabyInput",
  name: "futureBabyInput",
  component: futureBabyInput
}, {
  path: "/futureBabyResult",
  name: "futureBabyResult",
  component: futureBabyResult
}, {
  path: "/composeProcess",
  name: "composeProcess",
  component: composeProcess
}, {
  path: "/beautyContestScaning",
  name: "beautyContestScaning",
  component: beautyContestScaning
}, {
  path: "/beautyContestResult",
  name: "beautyContestResult",
  component: beautyContestResult
}, {
  path: "/personalFutrue",
  name: "personalFutrue",
  component: personalFutrue
}, {
  path: "/ethnicityScanner",
  name: "ethnicityScanner",
  component: ethnicityScanner
}, {
  path: "/vipcenter",
  name: "vipcenter",
  component: vipcenter
}, {
  path: "/zodiacMatch",
  name: "zodiacMatch",
  component: zodiacMatch
}, {
  path: "/zodiacMatchResult",
  name: "zodiacMatchResult",
  component: zodiacMatchResult
}, {
  path: "/loveCompatibility",
  name: "loveCompatibility",
  component: loveCompatibility
}, {
  path: "/loveCompatibilityResult",
  name: "loveCompatibilityResult",
  component: loveCompatibilityResult
}, {
  path: "/palmistryResult",
  name: "palmistryResult",
  component: palmistryResult
}, {
  path: "/loveConsultant",
  name: "loveConsultant",
  component: loveConsultant
}, {
  path: "/wealthForecast",
  name: "wealthForecast",
  component: wealthForecast
}, {
  path: "/palmPrintReading",
  name: "palmPrintReading",
  component: palmPrintReading
}, {
  path: "/palmPrintQuestion",
  name: "palmPrintQuestion",
  component: palmPrintQuestion
}, {
  path: "/palmPrintResult",
  name: "palmPrintResult",
  component: palmPrintResult
}, {
  path: "/faceReading",
  name: "faceReading",
  component: faceReading
}, {
  path: "/faceReadingTypes",
  name: "faceReadingTypes",
  component: faceReadingTypes
}, {
  path: "/faceReadingQuestion",
  name: "faceReadingQuestion",
  component: faceReadingQuestion
}, {
  path: "/faceReadingResult",
  name: "faceReadingResult",
  component: faceReadingResult
}, {
  path: "/vipPage",
  name: "vipPage",
  component: vipPage
}, {
  path: "/vipPlanC",
  name: "vipPlanC",
  component: vipPlanC
}, {
  path: "/vipPlanF",
  name: "vipPlanF",
  component: vipPlanF
}, {
  path: "/vipPlanFnew",
  name: "vipPlanFnew",
  component: vipPlanFnew
}, {
  path: "/chooseCelebrate",
  name: "chooseCelebrate",
  component: chooseCelebrate
}, {
  path: "/chooseAnotherPhoto",
  name: "chooseAnotherPhoto",
  component: chooseAnotherPhoto
}, {
  path: "/horoscopePage",
  name: "horoscopePage",
  component: horoscopePage
}, {
  path: "/getCelebrites",
  name: "getCelebrites",
  component: getCelebrites
}, {
  path: "/articalResult",
  name: "articalResult",
  component: articalResult
}, {
  path: "/galleryResult",
  name: "galleryResult",
  component: galleryResult
}, {
  path: "/readListPage",
  name: "readListPage",
  component: ReadListPage
}, {
  path: "/getNewCelebrites",
  name: "getNewCelebrites",
  component: GetNewCelebrites
}]; // console.log("store", store);
// if (!store.getters[types.GETTET_ISVIP]) {
//   staticRouters[0] = {
//     path: "/",
//     redirect: "/vipcenter"
//   };
// }

export default new Router({
  mode: "history",
  routes: staticRouters // scrollBehavior(to, from, savedPosition) {
  //   console.log(to)
  //   console.log(from)
  //   console.log(savedPosition)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }

});